export const NAVIGATION_CATEGORY_DISCOVER = "discover";
export const NAVIGATION_CATEGORY_COMPANY = "myCompany";
export const NAVIGATION_CATEGORY_MY_BKK = "myBkk";
export const NAVIGATION_CATEGORY_FEED = "feed";
export const NAVIGATION_CATEGORY_HOME = "home";
export const NAVIGATION_CATEGORY_CHALLENGES = "challenges";

export const NAVIGATION_CATEGORY_CHOICES = [
  NAVIGATION_CATEGORY_DISCOVER,
  NAVIGATION_CATEGORY_COMPANY,
  NAVIGATION_CATEGORY_MY_BKK,
  NAVIGATION_CATEGORY_FEED,
  NAVIGATION_CATEGORY_HOME,
  NAVIGATION_CATEGORY_CHALLENGES,
];
